import { ImageComponent } from "../../../../Pages/Home/Components/HomePageAfterSelectCategory"
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

const MobileCategory = ({ categoryData, handleCategoryClick, handleClearCategory }) => {
    const handleCategoryBackClick = () => {
        if (categoryData.currentCategory.parentNodeId === 0) {
            handleClearCategory(false)
        }
        else {
            handleCategoryClick(categoryData.parentCategory)
        }
    }

    return (<div className="container-fluid">
        <div className="row mobile-selected-category mb-2">
            <div className="col-auto d-flex align-items-center">
                <MdKeyboardArrowLeft size={25} onClick={() => handleCategoryBackClick()} />
            </div>
            <div className="col-2">
                <ImageComponent path={categoryData.currentCategory.catFileName} />
            </div>
            <div className="col d-flex flex-column">
                <div className="d-flex align-items-center">
                    <span>{categoryData.currentCategory.catDescription}</span>
                    <span className="ms-2 secondary-text">{`(${categoryData.currentCategory.artCount})`}</span>
                </div>
                <span className="secondary-text">{categoryData.currentCategory.catDetailDesc}</span>
            </div>
        </div>
        {categoryData.currentCategory.subCategories && categoryData.currentCategory.subCategories.map((c, index) => {
            return <div className="row main-category-mobile" key={index} onClick={() => handleCategoryClick(c)}>
                <div className="col">
                    <span>{c.catDescription}</span>
                    <span className="ms-2 secondary-text">{`(${c.artCount})`}</span>
                </div>
                <div className="col-2">
                    <MdOutlineKeyboardArrowRight size={25} />
                </div>
            </div>
        })}
    </div>)
}

export default MobileCategory